import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api/api-service';
import { requests } from '../../config/config';
import { finalize } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated: boolean = false
  // private token: string = ''
  private token: string | null = null;
  private readonly azureTokenKey = 'temp_token';
  // public signal exposing the user object returned by login API
  user = signal<any | null>(null);

  constructor(private router: Router, private apiService: ApiService) {
    this.restoreAuthState()
  }

  isBrowser(): boolean {
    return typeof window !== 'undefined'
  }

  restoreAuthState(): void {
    if (this.isBrowser()) {
      this.token = localStorage.getItem('token') || ''
      this.isAuthenticated = !!localStorage.getItem('token')
      if (!this.isAuthenticated) {
        this.token = localStorage.getItem(this.azureTokenKey) || null;
      }
      const storedUser = localStorage.getItem('user');
      this.user.set(storedUser ? JSON.parse(storedUser) : null);
    }
  }

  // PURE check (safe for guards)
  isAuthenticateUser(): boolean {
    return this.isAuthenticated;
  }
  
  // isAuthenticateUser(): boolean {
  //   if (!this.isBrowser()) {
  //     return false
  //   }
  //   this.isAuthenticated = !!localStorage.getItem('token')
  //   this.token = localStorage.getItem('token') || ''
  //   return !!localStorage.getItem('token')
  // }

  setAuthToken(token: string): void {
    if (this.isBrowser()) {
      localStorage.setItem('token', token)
      localStorage.removeItem(this.azureTokenKey);
      this.token = token
      this.isAuthenticated = true
    }
  }

  setAzureToken(token: string): void {
    if (this.isBrowser()) {
      localStorage.setItem(this.azureTokenKey, token);
      this.token = token;
      this.isAuthenticated = false;
    }
  }

  clearAzureToken(): void {
    if (this.isBrowser()) {
      localStorage.removeItem(this.azureTokenKey);
    }
  }

  setIsAuthenticated(value: boolean): void {
    this.isAuthenticated = value
  }

  clearToken(): void {
    if (this.isBrowser()) {
      localStorage.removeItem('token');
      localStorage.removeItem(this.azureTokenKey);
    }
    this.token = null;
    this.isAuthenticated = false
  }

  getAuthToken(): string | null {
    return this.token
  } 

  setUser(user: any) {
    this.user.set(user);
    if (this.isBrowser()) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }

  clearUser() {
    this.user.set(null);
    if (this.isBrowser()) {
      localStorage.removeItem('user');
    }
  }

  logout(): void {
    // call server logout then clear local state regardless of success
    this.apiService
      .sendRequest(requests.logout, 'post', {})
      .pipe(finalize(() => {
        this.clearToken();
        this.clearUser();
        localStorage.clear();
        // if (this.isBrowser()) {
        //   localStorage.removeItem('selectedRole');
        // }
        this.router.navigate(['/login']);
      }))
      .subscribe({
        next: () => { },
        error: () => { }
      });
  }

}
